export default "__VITE_ASSET__9604f2ea__"